import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AppService } from "@irb/app.service";
import { IrbModelsEvents } from "@irb-common/events";
import { ImportSecurityModelsUnrecognizedGridLayoutService } from "@irb/irb-models/import-security-model-unrecognized-dialog/import-security-model-unrecognized.grid-layout.service";
import { ModelsService } from "@irb/irb-models//models-new/models.service";

@Component({ standalone: false,
  selector: "irb-import-security-model-unrecognized-dialog",
  templateUrl: "./import-security-model-unrecognized-dialog.component.html",
  styleUrls: ["./import-security-model-unrecognized-dialog.component.scss", "../../irb-common/styles/dialog.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportSecurityModelsUnrecognizedDialogComponent {
  grid: any;
  gridOptions: any;
  frameworkComponents: any;

  constructor(public dialogRef: MatDialogRef<ImportSecurityModelsUnrecognizedDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public as: AppService, private gls: ImportSecurityModelsUnrecognizedGridLayoutService, public modelsService: ModelsService) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this },
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
    //this.grid.api.sizeColumnsToFit();
  }

  completeUnrecognized() {
    if (this.data.noninventoried.Models && this.data.noninventoried.Models.length > 0) {
      this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_MODELS_CONTAINS, this.data);
    } else {
      this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_MODELS_RESULT, this.data);
    }

    this.close();
  }
}
